export class Login
{
    public username:string;
    public password: string;
    public impersonation_id: string;
    constructor()
    {
        this.username = '';
        this.password = '';
        this.impersonation_id = '';
    }
}

export class LoginModel {
  public grant_type: string;
  public username: string;
  public password: string;
  public impersonation_id: string;
  EndPointURL: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/login.ts